import CryptoJS from 'crypto-js'
import { JSEncrypt } from 'jsencrypt'

/**
 * 创建密钥
 * @returns AES密钥
 */
export function createAesKey() {
  const expect = 16
  let str = Math.random().toString(36).substr(2)
  while (str.length < expect) {
    str += Math.random().toString(36).substr(2)
  }
  str = str.substr(0, 16)
  return str
}

/**
 * AES加密
 * @param {*} word 加密字段
 * @param {*} keyStr AES密钥
 * @returns 
 */
export function DESencrypt(word, keyStr) {
  keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
  var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.DES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString();
}

/**
 * RSA加密算法
 * @param {*} pas 
 * @returns 
 */
export function RSAencrypt(pas,publickey) {
    let jse = new JSEncrypt();
    jse.setPublicKey(publickey);
    return jse.encrypt(pas)
}


// WEBPACK FOOTER //
// ./src/utils/aes.js